// extracted by mini-css-extract-plugin
var _1 = "TestGeneralFeedbackElement_alert__9d981";
var _2 = "TestGeneralFeedbackElement_root__03713";
export { _1 as "alert", _2 as "root" }
